import { render, staticRenderFns } from "./FormProductTypeLocale.vue?vue&type=template&id=164760b1&scoped=true&"
import script from "./FormProductTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormProductTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164760b1",
  null
  
)

export default component.exports